jQuery(document).ready(function() {

    var $body = $('body'),
        $wrapper = $('.modals'),
        classBodyModalVisible = 'show-modal',
        classModalVisible = 'modal--visible';

    // open modals
    $('[data-toggle="modal"]').click( function(e) {
        e.preventDefault();
        var target = $(this).data('modal-id');
        var $anchor = $(this);
        var $modal = $wrapper.find('[data-modal-id="'+target+'"]');

        if( $modal.length ) {
            $body.addClass(classBodyModalVisible);
            $wrapper.stop().fadeIn( 150, 'easeInOutCubic', function() {
                $modal.show();
                $anchor.trigger('modal.show');
                setTimeout( function() {
                    $modal.addClass(classModalVisible);
                }, 100 );


            });
        if (target == 'make-dinner-reservation') {
            var dishId = $(this).data('dish-id');
            var dishTargetId = 'hors-hydra-' + dishId;  
            var dishEid = 'hydra-' + dishId; 
            $modal.find('.hors-hydra').prop('id', dishTargetId); 

            $modal.find('.reservationWidget').prop('src', 'https://reservation.dish.co/widget/' + dishEid + '?&amp;eid=' + dishEid + '&amp;tagid=' + dishTargetId + 
                '&amp;width=100%25&amp;height=&amp;foregroundColor=&amp;backgroundColor=&amp;linkColor=&amp;errorColor=&amp;primaryButtonForegroundColor=&amp;primaryButtonBackgroundColor=&amp;secondaryButtonForegroundColor=&amp;secondaryButtonBackgroundColor=')
            }    
        }
    });

    $('.close-modal').click( function(e) {
        e.preventDefault();
        var $modal = $(this).closest('.modal');
        var target = $modal.attr('data-modal-id'); 

        if( $modal.length ) {
            $body.removeClass(classBodyModalVisible);
            $modal.removeClass(classModalVisible);
            setTimeout( function() {
                $wrapper.stop().fadeOut( 150, 'easeInOutCubic', function() {
                    $modal.hide();
                });
            }, 150 );
        }

        if (target == 'make-dinner-reservation') {
            // clear modal dish id and src to prevent overwrite issues
            $modal.find('.hors-hydra').removeAttr('id');
            $modal.find('.reservationWidget').removeAttr('src'); 
        }
    });


    /**
     * Timo Vos 2018-07-05: removed the whole click-outside modal functionality, because this gives problems
     * with the resengo widget. The document click event is fired after button click and then the button is removed
     * from the dom by resengo.
     */
    /*$(document).on('click', function(e) {
        // close modal when clicking outside window
        if ( ! $(e.target).closest('.modal').length > 0 ) {
            console.log($(e.target));
            if (
                $(e.target).hasClass('ui-datepicker-prev') ||
                $(e.target).hasClass('ui-datepicker-next') ||
                $(e.target).hasClass('rds-next-button') ) { // Resengo widget in modal
                return;
            }

            if ( $('.modals .modal.modal--visible').length > 0 ) {
                var $modal = $('.modals .modal.modal--visible');

                $('body').removeClass('show-modal');
                $modal.removeClass('modal--visible');
                setTimeout( function() {
                    $('.modals').stop().fadeOut( 150, 'easeInOutCubic', function() {
                        $modal.hide();
                    });
                }, 150 );
            }
        }
    });*/


    // if modal on pageload contains form with errors or confirmation messages, display modal
    $('.modals .modal').each( function() {
        var $modal = $(this);

        if( $modal.find('.gform_validation_error').length > 0 || $modal.find('.gform_confirmation_wrapper').length > 0 ) {
            $body.addClass(classBodyModalVisible);
            $wrapper.stop().fadeIn( 150, 'easeInOutCubic', function() {
                $modal.show();
                setTimeout( function() {
                    $modal.addClass(classModalVisible);
                }, 100 );
            });
        }
    });


    // auto-show modal
    $('.modals .modal.modal--auto-show').each( function() {
        let $modal = $(this),
            delay = $(this).data('modal-delay');

        if (typeof delay === 'undefined') {
            delay = 0;
        }

        setTimeout( function() {
            // check if no other modal is already visible
            if (!$body.hasClass(classBodyModalVisible)) {
                // no other modal is visible
                $body.addClass(classBodyModalVisible);
                $wrapper.stop().fadeIn(150, 'easeInOutCubic', function () {
                    $modal.show();
                    setTimeout(function () {
                        $modal.addClass(classModalVisible);
                    }, 100);
                });

            } else {
                // check if other modal is visible or just the overlay
                if ($('.modals .'+classModalVisible).length > 0) {
                    // other modal is visible: close this one first
                    let $oldModal = $('.modals .modal.'+classModalVisible);

                    $oldModal.removeClass(classModalVisible);
                    setTimeout( function() {
                        $oldModal.hide();
                        $modal.show();

                        setTimeout(function () {
                            $modal.addClass(classModalVisible);
                        }, 100);
                    }, 150 );
                } else {
                    // no other modal is visible but overlay is
                    $modal.show();
                    setTimeout(function () {
                        $modal.addClass(classModalVisible);
                    }, 100);
                }
            }
        }, delay);
    });

});